module.exports = __webpack_public_path__ + "img/Slide16.17c1408a.png";